import React from "react";
import FileSaver from "file-saver";
import { pathOr } from "ramda";
import { useDispatch } from "react-redux";
import { setPopup } from "../../actions/popupAction";
import {
  cernerDownloadArrow,
  downloadArrow,
  downloadArrowVeradigm,
} from "../../assets/svg";
import CustomButton from "../customButton";
import {
  CERNER_EHR_WHITELABEL,
  VERADIGM_EHR_WHITELABEL,
} from "../../constants/constants";

const ExportButton = ({
  isDownloading,
  fetchReportDataFromAPI,
  filename,
  className,
  downloadDirectly = false,
  disabled = false,
  extension = "xlsx",
  onDownload = () => {},
  showToolTip = true,
  title,
  fileType = "text/plain",
  tooltipText,
  buttonType,
}) => {
  const dispatch = useDispatch();
  const downloadReport = async () => {
    try {
      isDownloading(true);
      const reportData = await fetchReportDataFromAPI();
      if (!downloadDirectly) {
        const type = pathOr(fileType, ["headers", "content-type"], reportData);
        const blob = new Blob([reportData?.config?.data || reportData], {
          type:
            extension === "xlsx"
              ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              : type,
          encoding: "UTF-8",
        });
        FileSaver.saveAs(blob, filename);
      }
    } catch (e) {
      console.error(e);
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "message"],
            e
          ),
        })
      );
    }
    isDownloading(false);
    onDownload();
  };

  return (
    <CustomButton
      buttonType={buttonType}
      className={`ml-8 ${className} ${disabled ? "disable-button" : ""}`}
      tooltip={
        tooltipText
          ? tooltipText
          : showToolTip
            ? `Export ${extension.toUpperCase()}`
            : ""
      }
      onClick={downloadReport}
      title={
        title
          ? title
          : CERNER_EHR_WHITELABEL
            ? cernerDownloadArrow
            : VERADIGM_EHR_WHITELABEL
              ? downloadArrowVeradigm
              : downloadArrow
      }
    />
  );
};

export default ExportButton;
